<!-- Main Content -->
<div class="container mt-4">
    <!-- Title with Icon -->
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-file-invoice-dollar mr-2"></i>Invoices
    </h1>
  
    <!-- Description Below Title -->
    <p class="lead mb-4">
      Manage and view your invoices efficiently. Use the tabs to access different sections, including an overview of invoice metrics, a comprehensive list of invoices, and the user manual for guidance. The "Add Invoice" button allows you to add new invoices to the system.
    </p>
  
    <!-- Navigation Tabs -->
    <ul class="nav nav-tabs">
     <!--  <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#Overview">
          <i class="fas fa-chart-bar mr-2"></i> Overview
        </a>
      </li> -->
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#List">
          <i class="fas fa-list mr-2"></i> List
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#UserManual">
          <i class="fas fa-book mr-2"></i> User Manual
        </a>
      </li>
    </ul>
  
    <!-- Tab Content -->
    <div class="tab-content">
      <!-- Overview tab content -->
   <!--    <div id="Overview" class="tab-pane fade show active">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <ngx-charts-bar-vertical
                [results]="barChartData"
                [view]="[400,300]"
                [scheme]="'cool'"
                [gradient]="true"
                [xAxis]="true"
                [yAxis]="true"
                [legend]="true"
                [showXAxisLabel]="true"
                [showYAxisLabel]="true"
                xAxisLabel="Category"
                yAxisLabel="Number of Books">
              </ngx-charts-bar-vertical>
            </div>
            <div class="col-md-6">
              <ngx-charts-pie-chart
                [results]="pieChartData"
                [view]="[400,300]"
                [scheme]="'cool'"
                [legend]="true"
                [explodeSlices]="false"
                [labels]="true">
              </ngx-charts-pie-chart>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <ngx-charts-line-chart
                [results]="lineChartData"
                [view]="[400,300]"
                [scheme]="'cool'"
                [legend]="true"
                [xAxis]="true"
                [yAxis]="true"
                [autoScale]="true">
              </ngx-charts-line-chart>
            </div>
            <div class="col-md-6">
              <ngx-charts-pie-chart
                [results]="doughnutChartData"
                [view]="[400,300]"
                [scheme]="'cool'"
                [legend]="true"
                [explodeSlices]="false"
                [doughnut]="true"
                [labels]="true">
              </ngx-charts-pie-chart>
            </div>
          </div>
        </div>
      </div> -->
  
      <!-- List tab content -->
      <div id="List" class="tab-pane fade show active">
        <div class="container-fluid" style="background-color: white;">
          <!-- Button trigger modal -->
          <button class="btn btn-outline-primary mb-3" (click)="openAddDialog()">Add Invoice</button>
          <button
          href="#"
          role="button"
          class="btn btn-outline-warning btn-icon-split"
          (click)="loadInvoices()"
        >
          <span class="icon text-warning">
            <i class="fas fa-redo"></i>
          </span>
          <span class="text">Reload</span>
        </button>

          <!-- Invoice Table -->
          <div class="card mb-4">
            <div class="card-body">
              <div class="table-responsive">
                <!-- <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Invoice Number</th>
                      <th>Invoice Date</th>
                      <th>Vendor</th>
                      <th>Total Amount</th>
                      <th>Notes</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let invoice of invoices">
                      <td>{{ invoice.invoiceNumber }}</td>
                      <td>{{ invoice.invoiceDate | date }}</td>
                      <td>{{ invoice.vendor.name }}</td>
                      <td>{{ invoice.totalAmount | currency }}</td>
                      <td>{{ invoice.notes }}</td>
                      <td>
                        <button (click)="openEditDialog(invoice)" class="btn btn-primary">Edit</button>
                        <button (click)="deleteInvoice(invoice.id)" class="btn btn-danger">Delete</button>
                      </td>
                    </tr>
                  </tbody>
                </table> -->
                <div *ngIf="loadingIndicator; else loaded">
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
        
                <ng-template #loaded>
                  <ngx-datatable
                  class="bootstrap"
                  [rows]="invoices"
                  [columnMode]="'force'"
                  [headerHeight]="50"
                  [footerHeight]="50"
                  [rowHeight]="'auto'"
                  [limit]="10"
                  [loadingIndicator]="loadingIndicator"
                  [reorderable]="reorderable"
                  (select)="onSelect($event)"
                  (activate)="onActivate($event)">
  
                  <!-- Invoice Number -->
                  <ngx-datatable-column name="Invoice Number" [prop]="'invoiceNumber'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                     <span style="color: red;">{{ row.invoiceNumber }}</span> 
                    </ng-template>
                  </ngx-datatable-column>
  
                  <!-- Invoice Date -->
                  <ngx-datatable-column name="Invoice Date" [prop]="'invoiceDate'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.invoiceDate | date }}
                    </ng-template>
                  </ngx-datatable-column>
  
                  <!-- Vendor -->
                  <ngx-datatable-column name="Vendor" [prop]="'vendor.name'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span style="color: blue;">{{ row.vendor?.name }}</span>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <!-- Total Amount -->
                  <ngx-datatable-column name="Total Amount" [prop]="'totalAmount'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.totalAmount | currency }}
                    </ng-template>
                  </ngx-datatable-column>
  
                  <!-- Notes -->
                  <ngx-datatable-column name="Notes" [prop]="'notes'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.notes }}
                    </ng-template>
                  </ngx-datatable-column>
  
                  <!-- Actions -->
                  <ngx-datatable-column name="Actions">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      
                        <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Actions
                        </button>
                        <div class="dropdown-menu">
                            <a class="dropdown-item"  (click)="openEditDialog(row)">
                                <i class="fas fa-edit"></i> Edit
                            </a>
                            <a class="dropdown-item"  (click)="deleteInvoice(row.id)">
                                <i class="fas fa-trash"></i> Delete
                            </a>
                            <a  [class.disabled]="true"  class="dropdown-item" (click)="download()">
                                <i class="fas fa-file-download"></i> Download 
                            </a>
                            <a  [class.disabled]="true"  class="dropdown-item" (click)="pay()">
                                <i class="fas fa-money-bill-wave"></i> Add Payment
                            </a>
                           <!--  <a class="dropdown-item" href="#">
                                <i class="fas fa-clock"></i> Set Payment Reminder
                            </a>
                            <a class="dropdown-item" href="#">
                                <i class="fas fa-bell"></i> Notify Vendor
                            </a>
                            <a class="dropdown-item" href="#">
                                <i class="fas fa-info-circle"></i> Track Payment
                            </a> -->
                        </div>
                    
                    

                    </ng-template>
                  </ngx-datatable-column>
  
                </ngx-datatable>
                </ng-template>
                

              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- User Manual tab content -->
      <div id="UserManual" class="tab-pane fade" style="background-color: white;">
        <!-- Add your user manual content here -->
        <div>
          <!-- <markdown [src]="markdownContent" [data]="markdownContent"></markdown>  -->
           <div  [innerHTML]="markdownContent"></div>
       </div>
      </div>
    </div>
  </div>
  
  <!-- Modal for Invoice Information Form -->
  <div class="modal fade" id="invoiceFormModal" tabindex="-1" aria-labelledby="invoiceFormModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="invoiceFormModalLabel">Invoice Information Form</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form action="#" method="post">
            <div class="form-group">
              <label for="invoiceNumber">Invoice Number:</label>
              <input type="text" class="form-control" id="invoiceNumber" name="invoiceNumber" required>
            </div>
            <div class="form-group">
              <label for="shipmentDate">Shipment Date:</label>
              <input type="date" class="form-control" id="shipmentDate" name="shipmentDate" required>
            </div>
            <div class="form-group">
              <label for="billingDate">Billing Date:</label>
              <input type="date" class="form-control" id="billingDate" name="billingDate" required>
            </div>
            <div class="form-group">
              <label for="shippingCost">Shipping Cost:</label>
              <input type="number" class="form-control" id="shippingCost" name="shippingCost" step="0.01" required>
            </div>
            <div class="form-group">
              <label for="shippingFund">Shipping Fund:</label>
              <input type="number" class="form-control" id="shippingFund" name="shippingFund" step="0.01" required>
            </div>
            <div class="form-group">
              <label for="status">Status:</label>
              <select class="form-control" id="status" name="status">
                <option value="open">Open</option>
                <option value="close">Close</option>
              </select>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="showInactive" name="showInactive">
              <label class="form-check-label" for="showInactive">Show Inactive</label>
            </div>
            <button type="submit" class="btn btn-primary mt-3">Submit</button>
          </form>
        </div>
      </div>
    </div>
  </div>
  